import { type ForgotPasswordInput, forgotPasswordInput } from '@facture/contracts'
import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeftIcon, MailCheckIcon, MailIcon } from 'lucide-react'
import { useForm } from 'react-hook-form'
import { AuthShell } from '@/components/app/auth-shell'
import { Button } from '@/components/ui/button'
import { Field } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { api } from '@/lib/api'

export const Route = createFileRoute('/forgot-password')({ component: ForgotPasswordPage })

function ForgotPasswordPage() {
  const form = useForm<ForgotPasswordInput>({
    resolver: zodResolver(forgotPasswordInput),
    defaultValues: { email: '' },
  })
  const send = useMutation({
    mutationFn: (values: ForgotPasswordInput) => api.post('/auth/forgot-password', values, { global: true }),
  })

  return (
    <AuthShell>
      {send.isSuccess ? (
        <div className="text-center">
          <div className="mx-auto flex size-12 items-center justify-center rounded-2xl bg-success-soft text-success">
            <MailCheckIcon className="size-6" />
          </div>
          <h1 className="mt-5 font-semibold text-2xl tracking-tight">Revisá tu correo</h1>
          <p className="mt-2 text-muted-foreground text-sm">
            Si existe una cuenta con <strong className="text-foreground">{form.getValues('email')}</strong>,
            te enviamos un enlace para crear una contraseña nueva. Vale 1 hora.
          </p>
        </div>
      ) : (
        <>
          <h1 className="font-semibold text-[28px] tracking-tight">Recuperá tu contraseña</h1>
          <p className="mt-2 text-muted-foreground text-sm">
            Escribí tu correo y te enviamos un enlace para elegir una contraseña nueva.
          </p>
          <form onSubmit={form.handleSubmit((v) => send.mutate(v))} className="mt-8 grid gap-5" noValidate>
            <Field label="Correo electrónico" error={form.formState.errors.email}>
              {(control) => (
                <Input
                  {...control}
                  {...form.register('email')}
                  type="email"
                  autoComplete="email"
                  autoFocus
                  placeholder="nombre@empresa.com"
                  leading={<MailIcon />}
                  className="[&_input]:h-11"
                />
              )}
            </Field>
            <Button type="submit" size="lg" loading={send.isPending} className="w-full">
              Enviar enlace
            </Button>
          </form>
        </>
      )}
      <Link
        to="/login"
        className="mt-8 flex items-center justify-center gap-1.5 text-muted-foreground text-sm hover:text-foreground"
      >
        <ArrowLeftIcon className="size-4" /> Volver a iniciar sesión
      </Link>
    </AuthShell>
  )
}
